import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { USER_URL } from '@insite-store360/shared';
import { catchError, Observable, throwError } from 'rxjs';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class FeatureService {
  private readonly FEATURE_API = `${USER_URL}/feature`;
  constructor(
    private http: HttpClient,
    private errorHandler: ErrorHandlerService
  ) { }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
    } else {
    }
    return throwError(() => '');
  }

  getFeatureById(id: number): Observable<number> {
    return this.http
      .get<number>(`${this.FEATURE_API}/getByRoleId/${id}`)
      .pipe(catchError(this.errorHandler.handleError));
  }

  getFeatureByRoleIdAndCountry(): Observable<any[]> {
    return this.http
      .get<any[]>(`${this.FEATURE_API}/getByRoleIdAndCountry`)
      .pipe(catchError(this.errorHandler.handleError));
  }
}
